import { GET_VOUCHER_SALE, GET_TOTAL_STOCK, INVOICE_LIST, INVOICE_DOWNLOAD, INVOICE_UPDATE, GENERATE_INVOICE, CLEAR_INVOICE_PREVIEW, DELETE_DELEIVERY_NOTE } from "../../admin-constants";

const initialState = {
  voucherSaleData: {},
  stockData: {},
  invoiceListData: [], // Best practice: Initialize list as empty array
  pdfData: {},
  invoiceUpdateData: {},
  invoiceData:[]
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_VOUCHER_SALE: {
      return {
        ...state,
        voucherSaleData: payload,
      };
    }

    case GET_TOTAL_STOCK: {
      return {
        ...state,
        stockData: payload,
      };
    }

    case INVOICE_LIST: {
      return {
        ...state,
        invoiceListData: payload,
      };
    }

    case INVOICE_DOWNLOAD: {
      return {
        ...state,
        pdfData: payload,
      };
    }

case INVOICE_UPDATE: {
  const updatedDetails = payload.data;

  const updatedList = Array.isArray(state.invoiceListData)
    ? state.invoiceListData.map((item) => {
        if (item.invoiceid === updatedDetails.invoiceid) {
          return {
            ...item, // keep everything
            ...(updatedDetails.invoicenumber !== undefined && {
              invoicenumber: updatedDetails.invoicenumber,
            }),
            ...(updatedDetails.invoicedate !== undefined && {
              invoicedate: updatedDetails.invoicedate,
            }),
          };
        }
        return item;
      })
    : state.invoiceListData;

  return {
    ...state,
    invoiceListData: updatedList,
  };
}

case GENERATE_INVOICE: {
  const { deliverynoteids } = payload;

  return {
    ...state,
    voucherSaleData: {
      ...state.voucherSaleData,
      data: Array.isArray(state.voucherSaleData?.data)
        ? state.voucherSaleData.data.filter(
            (item) => !deliverynoteids.includes(item.deliverynoteid)
          )
        : [],
    },
  };
}


    case CLEAR_INVOICE_PREVIEW:
  return {
    ...state,
    pdfData: null,
  };


     case DELETE_DELEIVERY_NOTE: {
          const updatedList = state.voucherSaleData.data.filter(
            (item) => item.deliverynoteid !== parseInt(payload.deliverynoteid)
          );
          return {
            ...state,
            voucherSaleData: updatedList,
          };
        }


    default:
      return state;
  }
};

export default reducer;